export default function NotFoundPage() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold">NotFoundPage</h1>
    </div>
  );
}
